import i18n from "@/i18n";
import { DeclarationPropertiesTypes } from "../../data/enums/declarationPropertiesTypes";
import { OperationRequestData } from "../../data/operationRequestData";
import { OperationModel } from "../operations/operationModel";
import { ContractModel } from "../contracts/contractModel";
import { CardModel } from "../contracts/cardModel";
import { EventCode } from "../../data/enums/eventCode";

/** Модель ссмены пароля */
export class CardBlockModel extends OperationModel {
  get type(): string{
    return  this.isBlock ? "block" : "unblock"
  }

  public isBlock: boolean = true
  public contract: ContractModel = new ContractModel()
  public card: CardModel = new CardModel()
  
  constructor(src: any) {
    super();
    this.isBlock = src.isBlock;
    this.contract = src.contract;
    this.card = src.card;
    this.Caption = i18n
    .t(
      `main.cards.actions.${this.isBlock ? "blockCardTitle" : "unblockCardTitle"
      }`,
      { pan: this.card.Data.Number }
    )
    .toString()
  }

  /**
   * Создание запроса операции.
   */
  public createOperationRequest(): OperationRequestData {
    const ord = new OperationRequestData();
    ord.respondentCode = this.RespondentCode;
    ord.operationId = this.OperationId;
    ord.EventCode = EventCode.Request;

    ord.setProperty("type", this.type, DeclarationPropertiesTypes.String);
    ord.setProperty(
      "contract",
      this.contract.Data.ReferenceId,
      DeclarationPropertiesTypes.String
    );
    ord.setProperty("card", this.card.Data.ReferenceId, DeclarationPropertiesTypes.String);

    return ord;
  }

  /**
   * Заполнение операции данными из ответа запроса.
   * @param ord Данные запроса.
   * @param bAssign Признак assign.
   */
  public setOperationFromRequest(...args: any[]): void {
    console.log("No implemetation");
  }
}
